import { useBreadcrumbTrail } from '@/data/Content/BreadcrumbTrail';
import {
	buildProductCategoryEntityViewNames,
	buildProductEntityViewName,
	useAdobeTargetEntityView,
} from 'presentation/events/hooks/adobe/useAdobeTargetEntityView';

export const useAdobePDPViews = (partNumber: string | undefined) => {
	const { breadcrumb } = useBreadcrumbTrail();
	const categoryEntityViewNames = buildProductCategoryEntityViewNames(breadcrumb);

	useAdobeTargetEntityView(categoryEntityViewNames[0]);
	useAdobeTargetEntityView(categoryEntityViewNames[1]);
	useAdobeTargetEntityView(categoryEntityViewNames[2]);
	useAdobeTargetEntityView(buildProductEntityViewName(partNumber));
};
